import merge from 'lodash.merge';
function mergePalettes(basePalette, subPalette) {
  return merge(basePalette, subPalette);
}
export default mergePalettes;